<app-navbar></app-navbar>
<main class="main">
  <router-outlet></router-outlet>
</main>
